(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/assets/javascripts/utils/ui.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/assets/javascripts/utils/ui.js');

'use strict';

const hideFooter = () => {
  var _document$querySelect;
  return (_document$querySelect = document.querySelector('.page-footer')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.classList.add('hide-page-footer');
};
const showFooter = () => {
  var _document$querySelect2;
  return (_document$querySelect2 = document.querySelector('.page-footer')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.classList.remove('hide-page-footer');
};
Object.assign(svs.lyckoplatsen.utils.ui, {
  hideFooter,
  showFooter
});

 })(window);